import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "nameInputTravelKit",
})
export class NameInputTravelKitPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value === null || value === undefined || value === "") {
      return "";
    }
    return value.split("/").pop();
  }
}
